import React, { FC, useEffect, useMemo, useRef, useState } from 'react';

import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { DropDownOptions } from 'devextreme-react/select-box';
//devextreem
import { TextBox } from 'devextreme-react/text-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppFieldBox } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { DateBox, NumberBox, SelectBox } from 'devextreme-react';
import { Popup } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';
import { ContractorLegalSelect } from 'pages/RequestTask/Views/TaskDetail/View/DetailMainInfo/components';

import { setTtn } from 'bus/report/actions';
import { TtnParameterSetRequest } from 'bus/report/types';

import { useDispatchPromise } from 'hooks/useDispatchPromise';

const storeContragent = () => {
  const defaultFilter = ['isOwner', '=', true];
  return $createDataSource('/v1/Contractor', 'id', {
    pageSize: 20,
    paginate: true,
    defaultFilter,
  });
};

type Props = {
  visible: boolean;
  onClose: () => void;
  dataRepost: TtnParameterSetRequest;
};

const ReportTtn2Modal: FC<Props> = ({ visible, onClose, dataRepost }) => {
  let validationRef = useRef<ValidationGroup>(null);
  const dispatch = useDispatchPromise();

  const storeTransport: any = useMemo(() => {
    const defaultFilter = ['id', '>', '0'];
    return $createDataSource('/v1/Transport', 'id', { defaultFilter });
  }, []);

  const storeEmployee: any = useMemo(() => {
    const defaultFilter = [['postId', '>=', 1], 'and', ['postId', '<=', 3]];
    const defaultSort = [{ selector: 'fullName', desc: false }];
    return $createDataSource('/v1/employee', 'id', { defaultFilter, defaultSort });
  }, []);

  const storeContractorLegal = useMemo(
    () =>
      $createDataSource('/v1/ContractorLegal', 'id', {
        pageSize: 200,
        paginate: true,
      }),
    [],
  );

  const [form, setForm] = useState<TtnParameterSetRequest>({
    carrierId: null,
    nomenclatureName: '',
    requestWorkId: 0,
    quantity: 0,
    driverId: null,
    transportId: null,
    version: 2,
    updNumber: '',
    updDate: '',
    builderId: null,
    consigneeId: null,
  });

  const [list, setList] = useState([]);

  useEffect(() => {
    if (dataRepost) {
      setForm(dataRepost);
      storeContragent()
        .load()
        .then((res) => {
          setList(res);
          setForm(dataRepost);
        });
    }
  }, [dataRepost]);

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();
    if (validationRef.current?.instance.validate().isValid) {
      await dispatch(setTtn.async(form));
      onClose();
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={onClose}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Отчет"
        width={460}
        onHidden={onClose}
        height={'auto'}
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={validationRef}>
                <Form id="report" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppFiledBox label="Номенклатура" labelTop>
                      <TextBox
                        stylingMode="underlined"
                        placeholder=""
                        mode="text"
                        value={form.nomenclatureName}
                        onValueChange={(e: any) => {
                          setForm((prev) => ({ ...prev, nomenclatureName: e }));
                        }}
                      >
                        <Validator>
                          <RequiredRule message="Заполните поле номенклатура" />
                        </Validator>
                      </TextBox>
                    </AppFiledBox>

                    <AppFiledBox label="Дата УПД" labelTop>
                      <DateBox
                        stylingMode="underlined"
                        type="date"
                        onValueChange={(e) => {
                          setForm((prev) => ({ ...prev, updDate: e as string }));
                        }}
                        useMaskBehavior
                        dateSerializationFormat="yyyy-MM-ddTHH:mm:ssx"
                        value={form.updDate}
                      ></DateBox>
                    </AppFiledBox>

                    <AppFiledBox label="№ УПД" labelTop>
                      <TextBox
                        stylingMode="underlined"
                        placeholder=""
                        mode="text"
                        value={form.updNumber}
                        onValueChange={(e: any) => {
                          setForm((prev) => ({ ...prev, updNumber: e }));
                        }}
                      >
                        <Validator>
                          <RequiredRule message="Заполните поле № УПД" />
                        </Validator>
                      </TextBox>
                    </AppFiledBox>

                    <AppFieldBox label="Грузоперевозчик" labelTop>
                      <div className="d-flex align-center">
                        <SelectBox
                          stylingMode="underlined"
                          style={{ width: '100%' }}
                          placeholder="Выберите грузоперевозчика"
                          mode="text"
                          value={form.carrierId}
                          onValueChanged={(e) => {
                            if (e.value) {
                              setForm((prev) => ({ ...prev, carrierId: e.value }));
                            } else {
                              setForm((prev) => ({ ...prev, carrierId: null }));
                            }
                          }}
                          searchMode="contains"
                          searchExpr={['name', 'inn']}
                          searchEnabled
                          displayExpr="name"
                          valueExpr="id"
                          items={list}
                        >
                          <Validator>
                            <RequiredRule message="Выберите грузоперевозчика" />
                          </Validator>
                        </SelectBox>
                      </div>
                    </AppFieldBox>

                    <ContractorLegalSelect
                      label="Подрядчик"
                      placeholder="Выберите подрядчика"
                      value={form.builderId ?? null}
                      readOnly={false}
                      showCreateButton={false}
                      preloadOnMount={false}
                      storeContractorLegal={storeContractorLegal}
                      onChange={(v) => setForm((prev) => ({ ...prev, builderId: v }))}
                    />
                    <ContractorLegalSelect
                      label="Грузополучатель"
                      placeholder="Выберите грузополучателя"
                      value={form.consigneeId ?? null}
                      readOnly={false}
                      showCreateButton={false}
                      preloadOnMount={false}
                      storeContractorLegal={storeContractorLegal}
                      onChange={(v) => setForm((prev) => ({ ...prev, consigneeId: v }))}
                    />

                    <AppFiledBox label="Объем" labelTop requere>
                      <NumberBox
                        stylingMode="underlined"
                        placeholder="Объем"
                        format="###0.##"
                        value={form.quantity}
                        onValueChanged={(e) => {
                          setForm((prev) => ({ ...prev, quantity: e.value }));
                        }}
                      >
                        <Validator>
                          <RequiredRule message="Заполните поле Объем" />
                        </Validator>
                      </NumberBox>
                    </AppFiledBox>
                    <AppFiledBox label="Транспорт" labelTop requere>
                      <SelectBox
                        stylingMode="underlined"
                        dataSource={storeTransport}
                        displayExpr="fullName"
                        valueExpr="id"
                        value={form.transportId}
                        searchEnabled
                        onItemClick={(e) => {
                          setForm((prev) => ({ ...prev, transportId: e.itemData.id }));
                        }}
                        onValueChanged={(e) => {
                          if (!e.value) {
                            setForm((prev) => ({ ...prev, transportId: null }));
                          }
                        }}
                        showClearButton
                      >
                        <DropDownOptions title="Выберите Транспорт" closeOnOutsideClick={true} showTitle={false} />
                        <Validator>
                          <RequiredRule message="Выберите Транспорт" />
                        </Validator>
                      </SelectBox>
                    </AppFiledBox>
                    <AppFiledBox label="Водитель" labelTop requere>
                      <SelectBox
                        stylingMode="underlined"
                        dataSource={storeEmployee}
                        displayExpr="fullName"
                        valueExpr="id"
                        value={form.driverId}
                        searchEnabled
                        onItemClick={(e) => {
                          setForm((prev) => ({ ...prev, driverId: e.itemData.id }));
                        }}
                        onValueChanged={(e) => {
                          if (!e.value) {
                            setForm((prev) => ({ ...prev, driverId: null }));
                          }
                        }}
                        showClearButton
                      >
                        <DropDownOptions title="Выберите водителя" closeOnOutsideClick={true} showTitle={false} />
                        <Validator>
                          <RequiredRule message="Выберите водителя" />
                        </Validator>
                      </SelectBox>
                    </AppFiledBox>
                  </Item>
                </Form>

                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={onClose}
                  textConfirm="Скачать"
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default ReportTtn2Modal;
